import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ModelSignal } from '@angular/core';
import { IPHXOutputComponent } from '../../../../@core/interfaces/IPHXOutputComponent.interface';
import { Task } from '../../../../generated/generated-types';
import { TaskPriorityWidgetComponent } from '../task-priority-widget/task-priority-widget.component';

@Component({
    selector: 'app-task-priority-column-widget',
    templateUrl: './task-priority-column-widget.component.html',
    styleUrl: './task-priority-column-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TaskPriorityWidgetComponent]
})
export class TaskPriorityColumnWidgetComponent implements IPHXOutputComponent {

    model: Task;
    modelSig?: ModelSignal<Task>;
    args: any;
    change: any;

    get task(): Task | null {
        return this.modelSig ? this.modelSig() : this.model;
    }

}

